import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';

import { BaseWebService } from "../shared/services/base-web.service";
import 'rxjs/add/observable/throw';

@Injectable()
export class VCPatientDetailsService {

    constructor(
        private _basewebservice: BaseWebService
    ) { }

    submitDetails(requestData: any, token: any, type: string) {
        const data: any = {};
        data.body = requestData;
        data.token = token;
        let url = 'v1/va/';
        if (type === 'vc-progress-checkup') {
            url = url + 'observer_checkup/';
        } else if (type === 'vc-retainer-checkup') {
            url = url + 'retainer_checkup/';
        } else if( type === 'vc-new-consultation'){
            url = url + 'virtual_consultation/';
        } else if(type === 'vc-emergency-checkup') {
            url = url + 'discomfort_checkup/';
        }
        return this._basewebservice.requestWithUrlToken(url, "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * Function for handling service call errors
     * @param  {Response|any} error contains error data
     */
    handleError(error: Response | any) {
        return Observable.throw(error);
    }

}